import { CheckboxFilter } from "@/components/ui/filters/CheckboxFilter";
import clsx from "clsx";
import "./CategoryContent.scss";
import { Col } from "@/components";
import { ReactNode } from "react";

type CategoryContentProps = {
  className?: string;
  canMultiple?: boolean;
  items: {
    id: string;
    label: string;
    checked: boolean;
    children?: ReactNode;
  }[];
  selectedItems: string[];
  onChange: (selected: string[]) => void;
};
export const CategoryContent = ({
  className = "",
  canMultiple = true,
  items,
  selectedItems,
  onChange,
}: CategoryContentProps) => {
  const handleCheckboxChange = (id: string) => {
    let newSelected: string[];
    if (canMultiple) {
      newSelected = selectedItems.includes(id)
        ? selectedItems.filter((item) => item !== id)
        : [...selectedItems, id];
    } else {
      if (selectedItems.includes(id)) {
        newSelected = [];
      } else {
        newSelected = [id];
      }
    }

    onChange(newSelected);
  };

  return (
    <Col className={clsx(className)}>
      {items.map((item, index) => {
        return (
          <div
            key={index}
            className={"ui-checkbox-border border-divider py-x8"}
          >
            <CheckboxFilter
              id={item.id}
              label={item.label}
              checked={item.checked}
              onChange={() => handleCheckboxChange(item.id)}
              classNameText={"fs-6 fw-regular"}
              canMultiple={canMultiple}
            />
            {item.checked && !!item.children ? (
              <div className="my-x8">{item.children}</div>
            ) : null}
          </div>
        );
      })}
    </Col>
  );
};
